export class CostCenterImportModel {
  counter: number = 0;
  branchCode: number = 0;
  code: number = 0;
  alterCode: string | null = null;
  name: string = "";
  costCenterTypeId: number = 0;
  constructionSiteCode: number = 0;
  priceListCode: number = 0;
  swInvoiceM2: boolean = false;
  unitValueM2: number = 0;
  swFixedQuota: boolean = false;
  valueFixedQuota: number = 0;
  invoicingModelCode: number = 0;
  ivaTypeId: number = 0;
  administrationRate: number = 0;
  incidentalRate: number = 0;
  utilityRate: number = 0;
  articleCode: number | null = null;
  conceptInvoicingCode: number | null = null;
  ratePromptPayment: number = 0;
  observation: string | null = null;

  constructor(counter: number,
    branchCode: number,
    code: number,
    alterCode: string | null,
    name: string,
    costCenterTypeId: number,
    constructionSiteCode: number,
    priceListCode: number,
    swInvoiceM2: boolean,
    unitValueM2: number,
    swFixedQuota: boolean,
    valueFixedQuota: number,
    invoicingModelCode: number,
    ivaTypeId: number,
    administrationRate: number,
    incidentalRate: number,
    utilityRate: number,
    articleCode: number | null,
    conceptInvoicingCode: number | null,
    ratePromptPayment: number,
    observation: string | null
  ) {
    this.counter = counter;
    this.branchCode = branchCode;
    this.code = code;
    this.alterCode = alterCode;
    this.name = name;
    this.costCenterTypeId = costCenterTypeId;
    this.constructionSiteCode = constructionSiteCode;
    this.priceListCode = priceListCode;
    this.swInvoiceM2 = swInvoiceM2;
    this.unitValueM2 = unitValueM2;
    this.swFixedQuota = swFixedQuota;
    this.valueFixedQuota = valueFixedQuota;
    this.invoicingModelCode = invoicingModelCode;
    this.ivaTypeId = ivaTypeId;
    this.administrationRate = administrationRate;
    this.incidentalRate = incidentalRate;
    this.utilityRate = utilityRate;
    this.articleCode = articleCode;
    this.conceptInvoicingCode = conceptInvoicingCode;
    this.ratePromptPayment = ratePromptPayment;
    this.observation = observation;
  }
}